export const QUESTLIST_ID = 'questlist';

export const QUESTLIST_TEMPLATE = 'template';

export const QUESTLIST_EMPTY_TEMPLATE_PARAM_VALUE = 'empty';

export const QUESTLIST_EMPTY_TEMPLATE_PARAM = `${QUESTLIST_TEMPLATE}=${QUESTLIST_EMPTY_TEMPLATE_PARAM_VALUE}`;
